import http from '../services/http'

export default class Task {
  eventHandlers = {}
  constructor (url) {
    this.url = url
    this.checkTaskStatus()
  }
  on (eventName, callback) {
    this.eventHandlers[eventName] = callback
  }
  checkTaskStatus = async () => {
    let response
    try {
      response = await http.get(this.url)
    } catch (e) {
      return (
        this.eventHandlers.error && this.eventHandlers.error({ exception: e })
      )
    }
    const { data } = response
    if (data.status === 'SUCCESS') {
      this.eventHandlers.result && this.eventHandlers.result(data.result)
    } else if (data.status === 'FAILURE') {
      this.eventHandlers.error && this.eventHandlers.error(data.error)
    } else {
      this.eventHandlers.progress &&
            this.eventHandlers.progress({
              ...data,
              url: this.url,
              progress: data.progress || 0
            })
      setTimeout(this.checkTaskStatus, 1000)
    }
  }
}
